export default "https://cdn-static.gokick.com/assets/cf07e8c5970f78b6a967654f4a6b4453caa2db11/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";